<template>
  <v-form class="ticket-dialog-form" lazy-validation ref="form">
    <form-control
      v-for="(elem, index) in formElements"
      :key="index"
      :config="elem"
      :index="index"
      ref="controls"
      @btnClick="handleSubmit"
      @btnCancel="handleCancel"
    />
  </v-form>
</template>

<script>
import FormControl from './FormControl.vue';

export default {
  name: 'CustomForm',
  props: {
    formElements: Array
  },
  components: {
    FormControl
  },
  data() {
    return {
    }
  },
  methods: {

    validate() {
      return this.$refs.form.validate();
    },

    async getData() {
      let controls = Array.isArray(this.$refs.controls) && this.$refs.controls.length
        ? this.$refs.controls
        : [this.$refs.controls];
      
      return (await Promise.all(controls.map(control => control.getData())))
        .filter(_ => _)
        .reduce((p, c) => {
          p = p.concat(c)
          return p
        }, [])
    },

    handleSubmit(control) {
      this.$emit('submit', control);
    },

    handleCancel(control) {
      this.$emit('cancel', control);
    }
  }
  
}
</script>